export const getOptimizedImageUrl = (originalUrl, options = {}) => {
  if (!originalUrl || typeof originalUrl !== 'string') {
    // console.log('🖼️ ImageOptimizer: Invalid or missing URL:', originalUrl);
    return 'https://placehold.co/600x400/e0e0e0/ffffff?text=Invalid+Image';
  }

  // If the URL is relative, prepend the API base URL.
  if (originalUrl.startsWith('/')) {
    const apiUrl = process.env.REACT_APP_API_URL || '';
    originalUrl = `${apiUrl}${originalUrl}`;
    // console.log(`🔄 ImageOptimizer: Converted relative URL to absolute: ${originalUrl}`);
  }

  // The Supabase optimization logic is temporarily bypassed.
  // To re-enable it, ensure the Supabase storage bucket is public and remove the early return.
  const supabaseStorageRegex = /(https:\/\/[a-zA-Z0-9-]+\.supabase\.co)\/storage\/v1\/object\/public\/([a-zA-Z0-9-]+)\/(.*)/;
  const match = originalUrl.match(supabaseStorageRegex);

  if (!match) {
    // Not a Supabase storage URL, but it might be a full URL from our backend. Return as is.
    return originalUrl;
  }

  // Return the original Supabase URL directly because the optimization service fails,
  // likely due to the storage bucket not being public.
  return originalUrl;
};

// Yeni fonksiyon: Responsive image set oluşturma
export const getResponsiveImageSet = (originalUrl, sizes = []) => {
  if (!originalUrl || typeof originalUrl !== 'string') {
    return originalUrl;
  }

  // Supabase URL'si değilse direkt döndür
  const supabaseStorageRegex = /(https:\/\/[a-zA-Z0-9-]+\.supabase\.co)\/storage\/v1\/object\/public\/([a-zA-Z0-9-]+)\/(.*)/;
  const match = originalUrl.match(supabaseStorageRegex);
  
  if (!match) {
    return originalUrl;
  }

  // Varsayılan boyutlar
  if (sizes.length === 0) {
    sizes = [400, 600, 800, 1200];
  }

  // Her boyut için optimize edilmiş URL oluştur
  const srcSet = sizes.map(size => {
    const optimizedUrl = getOptimizedImageUrl(originalUrl, { width: size, quality: 80 });
    return `${optimizedUrl} ${size}w`;
  }).join(', ');

  return {
    src: getOptimizedImageUrl(originalUrl, { width: 800, quality: 80 }),
    srcSet,
    sizes: '(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, 1200px'
  };
};